module.exports = __webpack_public_path__ + "media/mypage/images/000707117-12af8c0c5dbe02b64342324e6f029ba2.jpg";